import api from "@/api/v1-jwt/config/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  CalculateInvoiceFeePayload,
  CalculateInvoiceFeeResponse,
  CalculateInvoiceFeeResponseSchema,
} from "../types";

type CalculateInvoiceFeeParams = {
  userId: string;
  payload: CalculateInvoiceFeePayload;
};

const calculateInvoiceFee = async ({
  userId,
  payload,
}: CalculateInvoiceFeeParams): Promise<CalculateInvoiceFeeResponse> => {
  const url = `/platform/invoices/${userId}/calculate_fee`;
  const response = await api.post(url, payload);
  return CalculateInvoiceFeeResponseSchema.parse(response.data);
};

export const crudCalculateFee = {
  createOptions: (
    options?: UseMutationOptions<
      CalculateInvoiceFeeResponse,
      Error,
      CalculateInvoiceFeeParams
    >
  ) => {
    const defaultOptions: UseMutationOptions<
      CalculateInvoiceFeeResponse,
      Error,
      CalculateInvoiceFeeParams
    > = {
      mutationFn: calculateInvoiceFee,
    };
    return { ...defaultOptions, ...options };
  },
  useMutation: (
    options?: UseMutationOptions<
      CalculateInvoiceFeeResponse,
      Error,
      CalculateInvoiceFeeParams
    >
  ) => {
    const mutationOptions = crudCalculateFee.createOptions(options);
    return useMutation<
      CalculateInvoiceFeeResponse,
      Error,
      CalculateInvoiceFeeParams
    >(mutationOptions);
  },
};
